import { PureFunctional, React } from '../../react';
import Button, { IButtonProps } from './button';
import Highlight from './highlight';

import cx from './style.less';

export default PureFunctional<{ activeIndex: number, inverse?: boolean, fill?: boolean, onChange: any, 
    /* tslint:disable */
    children?: Array<React.ReactElement<IButtonProps>> 
    /* tslint:enable */
    }>(`TabsSelector`)(
    ({ activeIndex, inverse, fill, onChange, children }) => (
        <div className={cx('selector', { inverse, fill })}>
            <Highlight activeIndex={activeIndex} className={cx('selector-highlight', { inverse, fill })} itemClassName={cx('selector-item', { inverse, fill })}>
                {children.qSelect((el, idx) => {
                    return <Button key={idx} active={idx === activeIndex} inverse={inverse} fill={fill} title={el.props.title} onClick={() => onChange(idx)} />;
                })}
            </Highlight>
        </div>
    ));



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/tabs/selector.tsx